module.exports = __webpack_public_path__ + "static/img/home_service_images_38_h5_zh.ec9d6fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_service_images_38_h5_zh.png
// module id = y5bE
// module chunks = 34